import { http } from "@/shared/api/axios";
import { OvertimeWeeklyHoursSchema, type OvertimeWeeklyHours } from "../model/types";

export async function fetchWeeklyOvertimeHours(params?: {
  weekOf?: string;
  excludeShiftId?: number;
}): Promise<OvertimeWeeklyHours> {
  const { data } = await http.get("/v1/scheduler/overtime/weekly-hours", {
    params,
    _skipErrorToast: true,
  } as never);
  return OvertimeWeeklyHoursSchema.parse(data);
}
